import { Component, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { DropDownRequest, DropDownResponse, RequirmentTypeModel, WHLocationModel, StatusModel } from '../../models/DropDwon/DropDownRequest';
import { FormsModule } from '@angular/forms';
import { global } from '../../models/global';
import { ToastrService } from 'ngx-toastr';
import { RegionModel, RMHModel } from '../../models/DropDwon/RegionModel';
import { FinalRequirementService } from '../../Services/FinalRequirement/final-requirement.service';
import { FinalRquirementDetails, ApprovalHistory } from '../../Models/FinalRequirement/final-rquirement-details';
import { RequirementStatus } from '../../Models/Dashboard/DashboardFilters';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'final-requirment',
    templateUrl: './finalRequirment.component.html',
    styleUrls: ['./finalRequirment.component.css']
})
export class FinalRequirmentComponent implements OnInit {
    loader = 'none';
    IsRejected: boolean = false;
    displayReject = 'none';
    ApproveDisable: boolean = false;
    comment: string;
    @ViewChild('regionSelect') regionSelect;
    @ViewChild('yearSelect') yearSelect;
    @ViewChild('sd') sd;
    @ViewChild('sbu') sbu;
    @ViewChild('division') division;
    @ViewChild('zone') zone;
    @ViewChild('requirmentType') requirmentType;
    @ViewChild('WHLocationItem') WHLocationItem;
    @ViewChild('rmh') rmh;
    @ViewChild('year') year;
    @ViewChild('status') status;
    @ViewChild('productSelect') productSelect;
    @ViewChild('cropSelect') cropSelect;

    //cropSelect

    public RMHSettings = {};
    public RMHSelectedItems: RMHModel[];

    public form: FormGroup;

    public dropdownMonthSettings: {};

    public RegionSettings = {};
    public RegionselectedItems: RegionModel[];

    public SBUSettings = {};
    public SBUSelectedItem: SBUModel[];

    public DivisionSettings = {};
    public DivisionSelectedItem: DivisionModel[];

    public ZoneSettings = {};
    public ZoneSelectedItem: ZoneModel[];
    
    public YearSettings= {};
    public YearSelectedItem: YearModel[];


    public userId: string;
    public roleId: string;
    public isViewOnly: string;
    public FlagDropDown: string;

    public ddlRequest: DropDownRequest = new DropDownRequest();
    public ddlResponse: DropDownResponse = new DropDownResponse();
    public RequirmentTypeSettings = {};
    public requirmentTypeDdl: RequirmentTypeModel[];
    public requirmentDllValue: any;

    public WHLocationSettings = {};
    public whLocationDdl: WHLocationModel[];
    public whLocationDDlValue: any;
    public ProductSettings = {};
    public CropSettings = {};

    IsSubmittButtonDisable: boolean = true;
    endRecord: number = 0;
    finalReqDetails: FinalRquirementDetails[] = [];
    finalReqProdCropDetails: FinalRquirementDetails[] = [];
    approvefinalReqDetails: any[] = [];
    reqType: string;
    regionCode: string;
    wareHouseLocation: string;
    selectedReqType: string;
    selectedRegion: any[] = [];
    selectedSbu: any[] = [];
    selectedDivision: any[] = [];
    selectedZone: any[] = [];
    selectedRMH: any[] = [];
    approvalDetails: ApprovalHistory[] = [];
    commaSeperatedSbus: string;
    commaSeperatedDivisions: string;
    commaSeperatedZones: string;
    commaSeperatedRegions: string;
    commaSeperatedSDs: string;
    commaSeperatedRMH: string;
    selectedSDs: any[] = [];
    public SDSettings = {};
    public WarehouseLocationSettings = {};
    userName: string;
    approveEnable: boolean = false;
    rejectEnable: boolean = false;
    tabName: string = "Volume";
    selectedRegionMessage: any[] = [];
    selectedRegionMessageUnique: any[] = [];
    commaSeperatedRegionsMessage: string;
    isProduct: boolean = false;
    defaultValue = 'none';
    defaultValueCrop = 'none';
    displayApprove = 'none';
    isDisabledPreviousForHistory=true;
    isDisabledNextForHistory=true;
    startRecordForHistory:number=1;
    recordsOnCurrentPageForHistory:number=0;
    endRecordForHistory:number=0;
    totalRecordForHistory:number=0;
    currentPageForHistory:number=1;
    lastPageForHistory:number=1;
    //selectedStatus: string;
    	  //deepanshu code start
currentPageForHistory1: any;
lastPageForHistory1:any;
totalRecordForHistory1:any;
recordsOnCurrentPageForHistory1: number = 0;
startRecordForHistory1:number=1;

isDisabledPreviousForHistory1=true;
isDisabledNextForHistory1=true;
endRecordForHistory1: number;
//deepansh

    pageNo: any;
    totalRecord: any;
    currentPage: any;
    lastPage: any;
    isDisabledPrevious = true;
    isDisabledNext = false;
    defaultView: boolean = true;
    recordsOnCurrentPage: any = 10;
    currentDate = new Date();
    startRecord: any = 1;
    pagination: any[];
    public StatusSettings = {};
    public statusDdl: StatusModel[];
    public statusDllValue: any;
    public statusList: any;
    public dropdownStatusSettings: {};
    statusModel: RequirementStatus[] = [];
    selectedStatus: any[] = [];
    commaSeperatedStatus: string;
    constructor(private ddlServices: DropDownService, private toastr: ToastrService, private finalRequirementService: FinalRequirementService, private cd: ChangeDetectorRef) {
       debugger
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId');
        this.userName = localStorage.getItem('dsu_userName');
        this.isViewOnly = localStorage.getItem('dsu_isViewOnly');
        this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44" || this.roleId == "77") ? "DEFAULT" : "DEFAULT";
    }

    ngOnInit() {
        debugger;
        this.ApproveDisable = true;
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.tabName = 'ProductWise';
        this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse = response.data;
                    debugger;
                    // if(this.roleId== '43'){
                    //     this.ddlResponse.zone = response.data.zone;
                    // }
                    // if(this.roleId== '39'){
                    //     this.ddlResponse.division = response.data.division;
                    // }
                    // if(this.roleId== '44' || this.roleId== '28'|| this.roleId== '1' ){
                    //     this.ddlResponse.sbu = response.data.sbu;
                    // }
                    // this.GetSDData();
                    // this.GetWarehouseLocationData(this.sd.selectedItems, "TRUE");
                   
                    this.ddlResponse.year=response.data.year;
                    this.ddlResponse.product=response.data.product;
                    this.ddlResponse.crop=response.data.crop;
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : this.ddlResponse.year[0].currentrequirementYear,
                        text: this.ddlResponse.year[0].currentrequirementYear
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems = requiredItem
                    //   for(var i=0;i<this.year.selectedItems.length; i++){
                    //       this.yearSelect.push(this.year.selectedItems[i].text)
                    //   }
                    this.YearSetting();
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {

            });
        this.SBUMHSetting();
        this.DivisionSetting();
        this.ZoneSetting();
        this.RegionSetting();
        this.YearSetting();
        // this.requirmentTypeDdl = [{ id: 1, text: "Annual" }, { id: 2, text: "Additional" }];
        this.requirmentTypeDdl = [{ id: 1, text: "H1" },  { id: 2, text: "H2" },{ id: 3, text: "Additional" }];
        this.statusDdl = [{ id: 1, text: "Approve" }, { id: 2, text: "Reject" }];
        this.RequirmentTypeSetting();
        this.RMHSetting();
        this.SDSetting();
        this.WareHouseLocationSetting();
        this.getStatus();
        this.regionCode = '';
        // this.getApprovalHistory('', this.regionCode);
        if (this.roleId == '28') {
            this.approveEnable = true;
            this.rejectEnable = true;
        }
        this.StatusSetting();
        this.ProductSetting();
        this.CropSetting();
    }
    CropSetting() {
        this.CropSettings = {
            singleSelection: false,
            idField: 'cropId',
            textField: 'cropName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Crop Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ProductSetting() {
        this.ProductSettings = {
            singleSelection: false,
            idField: 'productId',
            textField: 'productName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    getStatus() {

        this.loader = 'block';
        this.bindStatusDropdownSetting();
        this.finalRequirementService.getStatus(this.userId, this.roleId)
            .subscribe((resData) => {
                this.statusModel = resData.data;
                this.statusList = this.statusModel;
                // this.Status = this.statusModel
                this.loader = 'none';

            });
    }
    bindStatusDropdownSetting() {
        this.dropdownStatusSettings = {
            singleSelection: false,
            text: "Select Status",
            idField: 'id',
            textField: 'status',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true,
            noDataAvailablePlaceholderText: 'No Status Found'
        };
    }

    StatusSetting() {
        this.StatusSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'text',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Status Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    RMHSetting() {
        this.RMHSettings = {
            singleSelection: false,
            idField: 'rmhCode',
            textField: 'rmhName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No RBM/RMH Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    WareHouseLocationSetting() {
        this.WarehouseLocationSettings = {
            singleSelection: false,
            idField: 'whId',
            textField: 'whName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Warehouse Location Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    SDSetting() {
        this.SDSettings = {
            singleSelection: false,
            idField: 'sdCode',
            textField: 'sdName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No WH Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    RegionSetting() {
        this.RegionSettings = {
            singleSelection: false,
            idField: 'regionCode',
            textField: 'regionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Region Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    SBUMHSetting() {
        this.SBUSettings = {
            singleSelection: false,
            idField: 'sbuCode',
            textField: 'sbuName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No SBU Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    DivisionSetting() {
        this.DivisionSettings = {
            singleSelection: false,
            idField: 'divisionCode',
            textField: 'divisionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Division Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ZoneSetting() {
        this.ZoneSettings = {
            singleSelection: false,
            idField: 'zoneCode',
            textField: 'zoneName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Zone Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    YearSetting(){
        this.YearSettings = {
          singleSelection: true,
          idField: 'year',
          textField: 'year',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          itemsShowLimit: 1,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Year Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false
        };
    }
    RequirmentTypeSetting() {
        this.RequirmentTypeSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'text',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Requirment Type Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    WHLocationSetting() {
        this.WHLocationSettings = {
            singleSelection: true,
            idField: 'WHId',
            textField: 'WHName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    public onSBUSelect(item: any) {
        this.selectedSbu = [];
        for (var i = 0; i < this.sbu.selectedItems.length; i++) {
            this.selectedSbu.push(this.sbu.selectedItems[i].id)
        }
        this.commaSeperatedSbus = this.selectedSbu.join(", ");
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelect(item: any) {
        this.selectedSbu = [];
        for (var i = 0; i < this.sbu.selectedItems.length; i++) {
            this.selectedSbu.push(this.sbu.selectedItems[i].id)
        }
        this.commaSeperatedSbus = this.selectedSbu.join(", ");

        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onSBUSelectAll(items: any) {
        this.selectedSbu = [];
        for (var i = 0; i < this.sbu.selectedItems.length; i++) {
            this.selectedSbu.push(this.sbu.selectedItems[i].id)
        }
        this.commaSeperatedSbus = this.selectedSbu.join(", ")
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelectAll(items: any) {
        this.selectedSbu = [];
        this.commaSeperatedSbus = '';
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    

    public onDivisionSelect(item: any) {
        this.selectedDivision = []
        for (var i = 0; i < this.division.selectedItems.length; i++) {
            this.selectedDivision.push(this.division.selectedItems[i].id)
        }
        this.commaSeperatedDivisions = this.selectedDivision.join(", ");

        this.GetDivisionWiseData(this.division.selectedItems);

    }
    public onDivisionDeSelect(item: any) {
        this.selectedDivision = []
        for (var i = 0; i < this.division.selectedItems.length; i++) {
            this.selectedDivision.push(this.division.selectedItems[i].id)
        }
        this.commaSeperatedDivisions = this.selectedDivision.join(", ")
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onDivisionSelectAll(items: any) {
        this.selectedDivision = []
        for (var i = 0; i < this.division.selectedItems.length; i++) {
            this.selectedDivision.push(this.division.selectedItems[i].id)
        }
        this.commaSeperatedDivisions = this.selectedDivision.join(", ")
        this.GetDivisionWiseData(this.division.selectedItems);
    }
    public onDivisionDeSelectAll(items: any) {
        this.selectedDivision = [];
        this.commaSeperatedDivisions = '';
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onZoneSelect(item: any) {
        this.selectedZone = [];
        for (var i = 0; i < this.zone.selectedItems.length; i++) {
            this.selectedZone.push(this.zone.selectedItems[i].id)
        }
        this.commaSeperatedZones = this.selectedZone.join(", ");

        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelect(item: any) {
        this.selectedZone = [];
        for (var i = 0; i < this.zone.selectedItems.length; i++) {
            this.selectedZone.push(this.zone.selectedItems[i].id)
        }
        this.commaSeperatedZones = this.selectedZone.join(", ");
        this.GetZoneWiseData(this.zone.selectedItems);
    }

    public onZoneSelectAll(items: any) {
        this.selectedZone = [];
        for (var i = 0; i < this.zone.selectedItems.length; i++) {
            this.selectedZone.push(this.zone.selectedItems[i].id)
        }
        this.commaSeperatedZones = this.selectedZone.join(", ");
        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelectAll(items: any) {
        this.selectedZone = [];
        this.commaSeperatedZones = '';
        this.GetZoneWiseData(this.zone.selectedItems);
    }

    GetSBUWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.division = response.data.division;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;
                    this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
                    this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });

                    //     if (response.data.rmh.length > 0)
                    //     this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                    // else
                    //     this.rmh.selectedItems = [];

                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {

            });
    }
    GetDivisionWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.rmh = response.data.rmh;
                    this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {

            });
    }
    GetZoneWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });

                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {

            });
    }

    onReqTypeSelect(item: any) {
        this.selectedReqType = item.text
        this.RequirmentTypeSetting();
        this.defaultValueCrop = "none";
        this.defaultValue = "none";

    }
    onReqTypeDeSelect(item: any) {
        this.selectedReqType = '';
        this.defaultValueCrop = "none";
        this.defaultValue = "none";
    }
    public onRegionSelect(item: any) {
        this.selectedRegion = [];
        for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
            this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
        }
        this.commaSeperatedRegions = this.selectedRegion.join(", ");
        this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
    public onRegionDeSelect(item: any) {
        this.selectedRegion = [];
        for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
            this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
        }
        this.commaSeperatedRegions = this.selectedRegion.join(", ");
        this.GetRegionWiseData(this.regionSelect.selectedItems);
    }

    public onRegionSelectAll(items: any) {
        this.selectedRegion = [];
        for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
            this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
        }
        this.commaSeperatedRegions = this.selectedRegion.join(", ");
        this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
    public onRegionDeSelectAll(items: any) {
        this.selectedRegion = [];
        this.commaSeperatedRegions = '';
        this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
    GetRegionWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.rmh.length > 0)
                        this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                    else
                        this.rmh.selectedItems = [];
                    // this.ddlResponse.rmh = response.data.rmh;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {

                this.loader = 'none';
            });
    }
    public onRMHSelect(item: any) {
        this.selectedRMH = [];
        for (var i = 0; i < this.rmh.selectedItems.length; i++) {
            this.selectedRMH.push(this.rmh.selectedItems[i].id)
        }
        this.commaSeperatedRMH = this.selectedRMH.join(", ");
        this.GetRMHWiseData(this.rmh.selectedItems);
        //this.getSDRMHWise(this.rmh.selectedItems);
        //this.getWHRMHWise(this.rmh.selectedItems);
    }
    public onRMHDeSelect(item: any) {

        this.selectedRMH = [];
        for (var i = 0; i < this.rmh.selectedItems.length; i++) {
            this.selectedRMH.push(this.rmh.selectedItems[i].id)
        }
        this.commaSeperatedRMH = this.selectedRMH.join(", ");
        this.GetRMHWiseData(this.rmh.selectedItems);

        // this.GetRMHWiseData(this.rmh.selectedItems);
        // this.getSDRMHWise(this.rmh.selectedItems);
        //this.getWHRMHWise(this.rmh.selectedItems);

    }

    public onRMHSelectAll(items: any) {
        this.selectedRMH = [];
        for (var i = 0; i < this.rmh.selectedItems.length; i++) {
            this.selectedRMH.push(this.rmh.selectedItems[i].id)
        }
        this.commaSeperatedRMH = this.selectedRMH.join(", ");
        this.GetRMHWiseData(this.rmh.selectedItems);

        //this.GetRMHWiseData(this.rmh.selectedItems);
        //this.getSDRMHWise(this.rmh.selectedItems);
        //this.getWHRMHWise(this.rmh.selectedItems);

    }
    public onRMHDeSelectAll(items: any) {
        this.selectedRMH = [];
        this.commaSeperatedRMH = '';
        //  this.GetRMHWiseData(this.rmh.selectedItems);
        // this.getSDRMHWise(this.rmh.selectedItems);
        // this.getWHRMHWise(this.rmh.selectedItems);
        this.GetRMHWiseData(this.rmh.selectedItems);


    }
    GetRMHWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getRMHWiseRegionDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.region = response.data.region;
                    if (response.data.region.length > 0  && this.ddlRequest.RMH != '')
                        this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    else
                        this.regionSelect.selectedItems = [];
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    getSDRMHWise(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getSDRMHWise(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.sd = response.data.sd;
                    this.getWHRMHWise(this.ddlRequest.RMH, this.ddlResponse.sd)
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    getWHRMHWise(filter: any, filterSD: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = filter;
        this.ddlRequest.SD = Array.prototype.map.call(filterSD, function (item) { return item.sdCode; }).join(",");
        this.ddlServices.getWHRMHWise(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    public onSDSelect(item: any) {
        // this.getWHRMHWise(this.rmh.selectedItems,this.sd.selectedItems)
        this.GetWarehouseLocationData(this.sd.selectedItems, "FALSE");
    }
    public onSDDeSelect(item: any) {
        this.GetWarehouseLocationData(this.sd.selectedItems, "FALSE");
    }

    public onSDSelectAll(items: any) {
        this.GetWarehouseLocationData(this.sd.selectedItems, "FALSE");
    }
    public onSDDeSelectAll(items: any) {
        this.GetWarehouseLocationData(this.sd.selectedItems, "FALSE");
    }
    GetWarehouseLocationData(filter: any, IsOnInit: string) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = IsOnInit;
        if (filter.length > 0)
            this.ddlRequest.SD = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        else
            this.ddlRequest.SD = '';
        this.ddlServices.getWarehouseLocationDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetSDData() {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlServices.getSDDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.sd = response.data.sd;
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
            });
    }
    ConvertToCurrency(value:any)
    {

        var parts = value.toString().replace(',','').split(".");
        if(parts[0].length > 3){
        parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
        }
        return parts.join(".");
    }
    getFinalRequirementData(reqType) {
        debugger;
        let region = ''
        //let year=0;
        this.loader = 'block';
        //year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        
        if (typeof (reqType) == "undefined" || reqType == '') {
            this.toastr.error('Please select requirement type.');
            this.loader = 'none';
            return false;
        }
        if (this.regionSelect.selectedItems.length > 0) {
            region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        
        else {
            this.toastr.error('Please select region.');
            this.loader = 'none';
            return false;
        }
        this.getFinalRequirementDetails(reqType,1);
        this.getApprovalHistory(1);

    }

    getFinalRequirementDetails(reqType,currentPageForHistory1: number) {
        debugger;
        this.isDisabledPrevious = true;
        this.isDisabledNext = false;
        this.startRecord = 1;
        reqType= Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
        let year=0;
        let status = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
        if (status == null || status == "") {
            status = "1";
        }
        let product=Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let crop=Array.prototype.map.call(this.cropSelect.selectedItems, function (item) { return item.id; }).join(",");
        this.reqType = reqType;
        if (this.tabName == "ProductWise") {
            // this.isProduct = true;
            this.isProduct = false;
        }
        else if (this.tabName == "Product&CropWise") {
            this.isProduct = false;
        } else {
            this.isProduct = false;
        }

        this.loader = 'block';
        if (this.commaSeperatedSbus == undefined) {
            this.commaSeperatedSbus = '';
        }
        if (this.commaSeperatedDivisions == undefined) {
            this.commaSeperatedDivisions = '';
        }
        if (this.commaSeperatedZones == undefined) {
            this.commaSeperatedZones = '';
        } if (this.commaSeperatedRegions == undefined) {
            this.commaSeperatedRegions = '';
        }
        if (this.commaSeperatedRMH == undefined) {
            this.commaSeperatedRMH = '';
        }
        if(this.yearSelect!=undefined){
            this.yearSelect.selectedItems=[];
        }
        if (this.commaSeperatedStatus == undefined) {
            this.commaSeperatedStatus = '';
        }
        if (this.regionSelect.selectedItems.length > 0) {
            this.regionCode = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.finalRequirementService.getFinalRequirementDetails(currentPageForHistory1,product,crop,this.userId, this.roleId, this.commaSeperatedSbus, this.commaSeperatedDivisions, this.commaSeperatedZones, this.regionCode, this.reqType, this.commaSeperatedRMH, this.isProduct,year, this.commaSeperatedStatus)
            .subscribe((finalReqData) => {
                if (finalReqData.status) {
                    console.log(finalReqData.data);
                    this.defaultView = false;
                    this.finalReqDetails = finalReqData.data.finalRequirementCropModels;
                    this.totalRecord = finalReqData.data.pagination.totalRecord;
                    this.currentPage = finalReqData.data.pagination.currentPage;
                    this.lastPage = finalReqData.data.pagination.lastPage;
                    this.recordsOnCurrentPage = finalReqData.data.pagination.recordsOnPage;
                    this.endRecord = this.recordsOnCurrentPage;
                    this.approveEnable = finalReqData.data.button.isNextButtonDisable;
                    this.rejectEnable = finalReqData.data.button.isPreviousButtonDisable;
                    if (this.currentPage == 1) {
                        localStorage.setItem("numberOfRecordsOnFirstPage", this.recordsOnCurrentPage.toString());
                    }
                    if (this.currentPage > 1) {
                        this.isDisabledPrevious = false;
                        this.startRecord = (this.currentPage - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPage"), 10) + 1;
                        this.endRecord = this.startRecord + this.recordsOnCurrentPage - 1;
                    }
                    if (this.currentPage == this.lastPage || this.totalRecord == 0) {
                        this.isDisabledNext = !this.isDisabledNext;
                        this.recordsOnCurrentPage = this.totalRecord;
                    } if (finalReqData.data.finalRequirementCropModels.length == 0) {
                        this.startRecord = 0;
                        this.endRecord = 0;
                        this.recordsOnCurrentPage = 0;
                    }
                }
                else {
                    this.toastr.error(finalReqData.message);
                }
                // if(approvalData.data == null){
                //     this.startRecordForHistory = 0;
                //     this.recordsOnCurrentPageForHistory = 0;
                //     this.endRecordForHistory = 0;
                //     this.totalRecordForHistory = 0;
                //     this.approvalDetails = [];
                //     this.isDisabledNextForHistory = true;
                // }
                // else{
                //     this.approvalDetails = approvalData.data.approvalHistoryModels;
                //     this.totalRecordForHistory=approvalData.data.pagination.totalRecord;
                //     this.currentPageForHistory= approvalData.data.pagination.currentPage; 
                //     this.lastPageForHistory = approvalData.data.pagination.lastPage;
                //     this.recordsOnCurrentPageForHistory = approvalData.data.pagination.recordsOnPage;
                //     this.endRecordForHistory = this.recordsOnCurrentPageForHistory;
                //     if (this.currentPageForHistory == 1)
                //     {
                //         localStorage.setItem("numberOfRecordsOnFirstPageForHistory", this.recordsOnCurrentPageForHistory.toString());
                //     }
                //     if (this.currentPageForHistory > 1)
                //     {
                //         this.isDisabledPreviousForHistory = false;
                //         // this.startRecordForHistory = (this.currentPageForHistory - 1) * (approvalData.data.length) + 1;
                //         this.startRecordForHistory = (this.currentPageForHistory - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPageForHistory"), 10) + 1;
                //         this.endRecordForHistory = this.startRecordForHistory + this.recordsOnCurrentPageForHistory - 1;
                //     }
                //     if (this.currentPageForHistory == this.lastPageForHistory || this.totalRecordForHistory == 0) {
                //         this.isDisabledNextForHistory = !this.isDisabledNextForHistory;
                //         this.recordsOnCurrentPageForHistory = this.totalRecordForHistory;
                //     }
                // }
                this.loader = 'none';
                if (this.tabName == 'ProductWise') {
                    if (finalReqData.data != null) {
                        this.defaultValue = 'block';
                    } else {
                        this.defaultValue = 'none';
                    }
                    this.finalReqDetails = finalReqData.data.finalRequirementCropModels;
                }
                else {
                    this.defaultValueCrop = 'block';
                    this.finalReqProdCropDetails = finalReqData.data;
                }
                this.selectedRegionMessage = [];
                if (this.finalReqDetails != null) {
                    this.selectedRegionMessage.push({ region: this.finalReqDetails[0].region, status: this.finalReqDetails[0].status })
                    for (var i = 0; i < this.finalReqDetails.length; i++) {

                        for (var j = 0; j < this.selectedRegionMessage.length; j++) {
                            if (this.selectedRegionMessage[j].region == this.finalReqDetails[i].region) {
                                break;
                            }

                        }
                        if (j == this.selectedRegionMessage.length) {
                            this.selectedRegionMessage.push({ region: this.finalReqDetails[i].region, status: this.finalReqDetails[i].status })
                        }
                    }
                }
                // if (this.finalReqDetails != null) {
                //     let isValid = false;
                //     for (let i = 0; i < this.finalReqDetails.length; i++) {
                       
                //         if (this.roleId == "39") 
                //         {
                //             if(this.finalReqDetails[i].status == 'Approval Pending at FMGM' ||   // Check added for FMGM role
                //                 this.finalReqDetails[i].status == 'Approval Pending at Brand Manager'|| 
                //                 this.finalReqDetails[i].status == 'Rejected By DMH'||
                //                 this.finalReqDetails[i].status == 'Rejected By Admin'||
                //                 this.finalReqDetails[i].status == 'Rejected By FMGM'||
                //                 this.finalReqDetails[i].status == 'Rejected By ZMH'||
                //                 this.finalReqDetails[i].status == 'Approval Pending at ZMH' ||
                //                 this.finalReqDetails[i].status == 'Partial approved by MKTG'||
                //                 this.finalReqDetails[i].status == 'Partially Approved from Brand Manager'||
                //                 this.finalReqDetails[i].status == 'Fully approved by MKTG')
                //             {
                //             isValid = true;
                //             this.loader = 'none';
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             return false

                //             }
                //             else{
                //                 isValid = false;
                //                 this.loader = 'none';
                //                 this.approveEnable = false;
                //                 this.rejectEnable = false;
                //                 // return false
                //             }
                //         }
                //         if (this.roleId == "43" || this.roleId == "77") 
                //         {
                //             if(
                //                 this.finalReqDetails[i].status == 'Approval Pending at DMH' ||
                //                 this.finalReqDetails[i].status == 'Approval Pending at FMGM' ||
                //                 this.finalReqDetails[i].status == 'Approval Pending at Brand Manager'||
                //                 this.finalReqDetails[i].status == 'Rejected By DMH' ||
                //                 this.finalReqDetails[i].status == 'Rejected By ZMH' ||
                //                 this.finalReqDetails[i].status == 'Rejected By Admin'||
                //                 this.finalReqDetails[i].status == 'Rejected By SBUMH' ||
                //                 this.finalReqDetails[i].status == 'Partial approved by MKTG'||
                //                 this.finalReqDetails[i].status == 'Partially Approved from Brand Manager'||
                //                 this.finalReqDetails[i].status == 'Fully approved by MKTG')
                //             {
                //                 isValid = true;
                //                 this.loader = 'none';
                //                 this.approveEnable = true;
                //                 this.rejectEnable = true;
                //                 return false
                //             }
                //             else{
                //                 isValid = false;
                //                 this.loader = 'none';
                //                 this.approveEnable = false;
                //                 this.rejectEnable = false;
                //                 // return false
                //             }
                //         }
                //         if (this.roleId == "44") 
                //         {
                //             if(this.finalReqDetails[i].status == 'Approval Pending at Brand Manager'||
                //             this.finalReqDetails[i].status == 'Rejected By SBUMH'||
                //             this.finalReqDetails[i].status == 'Rejected By DMH'||
                //             this.finalReqDetails[i].status == 'Rejected By Admin'||
                //             this.finalReqDetails[i].status == 'Rejected By ZBM/ZMH'||
                //             this.finalReqDetails[i].status == 'Approval Pending at DMH' ||
                //             this.finalReqDetails[i].status == 'Approval Pending at ZBM/ZMH'||
                //             this.finalReqDetails[i].status == 'Partial approved by MKTG' ||
                //             this.finalReqDetails[i].status == 'Partially Approved from Brand Manager'||
                //             this.finalReqDetails[i].status == 'Fully approved by MKTG')
                //             {
                //                 isValid = true;
                //                 this.loader = 'none';
                //                 this.approveEnable = true;
                //                  this.rejectEnable = true;
                //                  return false
                                
                //             }
                //             else{
                //                 isValid = false;
                //                 this.loader = 'none';
                //                 this.approveEnable = false;
                //                 this.rejectEnable = false;
                //                 // return false
                //             }
                //         }
                //         if (this.roleId == "36")  //Added for FMGM role
                //         {
                //             if(this.finalReqDetails[i].status == 'Approval Pending at Brand Manager'||
                //             this.finalReqDetails[i].status == 'Rejected By FMGM'||
                //             this.finalReqDetails[i].status == 'Rejected By DMH'||
                //             this.finalReqDetails[i].status == 'Rejected By Admin'||
                //             this.finalReqDetails[i].status == 'Rejected By ZBM/ZMH'||
                //             this.finalReqDetails[i].status == 'Approval Pending at DMH' ||
                //             this.finalReqDetails[i].status == 'Approval Pending at ZBM/ZMH'||
                //             this.finalReqDetails[i].status == 'Partial approved by MKTG' ||
                //             this.finalReqDetails[i].status == 'Partially Approved from Brand Manager'||
                //             this.finalReqDetails[i].status == 'Fully approved by MKTG')
                //             {
                //                 isValid = true;
                //                 this.loader = 'none';
                //                 this.approveEnable = true;
                //                  this.rejectEnable = true;
                //                  return false
                                
                //             }
                //             else{
                //                 isValid = false;
                //                 this.loader = 'none';
                //                 this.approveEnable = false;
                //                 this.rejectEnable = false;
                //                 // return false
                //             }
                //         }
                //         if (this.roleId == "1" || this.roleId=="37") 
                //         {
                //             if(this.finalReqDetails[i].status == 'Approval Pending at Brand Manager'||
                //             this.finalReqDetails[i].status == 'Rejected By FMGM'||
                //             this.finalReqDetails[i].status == 'Rejected By DMH'||
                //             this.finalReqDetails[i].status == 'Rejected By Admin'||
                //             this.finalReqDetails[i].status == 'Rejected By ZBM/ZMH' ||
                //             this.finalReqDetails[i].status == 'Partially Approved from Brand Manager'||
                //             this.finalReqDetails[i].status == 'Partial approved by Brand Manager')
                //             {
                //                 isValid = true;
                //                 this.loader = 'none';
                //                 this.approveEnable = true;
                //                  this.rejectEnable = true;
                //                  return false
                                
                //             }
                //             else{
                //                 isValid = false;
                //                 this.loader = 'none';
                //                 this.approveEnable = false;
                //                 this.rejectEnable = false;
                //                 // return false
                //             }
                //         }
                //     }
                //     if (isValid) {
                //         this.loader = 'none';
                //         this.approveEnable = true;
                //         this.rejectEnable = true;
                //     }
                // }

                // if (this.selectedRegionMessage.length >= 1) {
                //     for (var i = 0; i < this.selectedRegionMessage.length; i++) {
                //         if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager') {
                //             this.loader = 'none';
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //         }

                //         else if (this.selectedRegionMessage[i].status == 'Rejected By SBUMH') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else if (this.selectedRegionMessage[i].status == 'Rejected By DMH') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else if (this.selectedRegionMessage[i].status == 'Rejected By DMH') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else if (this.selectedRegionMessage[i].status == 'Rejected By ZMH') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else if (this.selectedRegionMessage[i].status == 'Approval Pending at DMH' && this.roleId == '43' || this.selectedRegionMessage[i].status == 'Rejected By ZMH' && this.roleId == '43') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else if (this.selectedRegionMessage[i].status == 'Approval Pending at SBUMH' && this.roleId == '39' || this.selectedRegionMessage[i].status == 'Rejected By DMH' && this.roleId == '39') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager' && this.roleId == '44' || this.selectedRegionMessage[i].status == 'Rejected By SBUMH' && this.roleId == '44') {
                //             this.approveEnable = true;
                //             this.rejectEnable = true;
                //             this.loader = 'none';
                //         }
                //         else {
                //             this.approveEnable = false;
                //             this.rejectEnable = false;
                //             this.loader = 'none';
                //         }
                //     }
                // }


                if (this.finalReqDetails == null || finalReqData.message == 'Failure' || this.finalReqProdCropDetails == null) {
                    this.defaultValue = 'none';
                    this.defaultValueCrop = 'none';
                    this.toastr.error('No data found.');
                    this.loader = 'none';
                }
                this.loader = 'none';

            });
    }

    downloadURLFinalReq(pageNoForExcel:number) {
        let status = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
        if (status == null || status == "") {
            status = "1";
        }
        let year=0;
        let today = new Date();
        let month;
        if((today.getMonth() + 1)<10)
        {
            month = '0' + (today.getMonth() + 1).toString().slice(-2);
        }
        else
        {
            month =  (today.getMonth() + 1).toString().slice(-2);
        }
        let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
        if (this.tabName == "ProductWise") {
            this.isProduct = true;
        }
        else if (this.tabName == "Product&CropWise") {
            this.isProduct = false;
        } else {
            this.isProduct = false;
        }
        if (typeof (this.selectedReqType) == "undefined" || this.selectedReqType == '') {
            this.toastr.error('Please select requirement type.');
            this.loader = 'none';
            return false;
        }
        this.loader = 'block';
        if (this.commaSeperatedSbus == undefined) {
            this.commaSeperatedSbus = '';
        }
        if (this.commaSeperatedDivisions == undefined) {
            this.commaSeperatedDivisions = '';
        }
        if (this.commaSeperatedZones == undefined) {
            this.commaSeperatedZones = '';
        } if (this.commaSeperatedRegions == undefined) {
            this.commaSeperatedRegions = '';
        }
        if (this.commaSeperatedRMH == undefined) {
            this.commaSeperatedRMH = '';
        }
        if(this.yearSelect!=undefined){
            this.yearSelect.selectedItems=[];
        }
        if (this.commaSeperatedStatus == undefined) {
            this.commaSeperatedStatus = '';
        }
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.finalRequirementService.getFinalRequirementDetailsExcel(pageNoForExcel,this.userId, this.roleId, this.commaSeperatedSbus, this.commaSeperatedDivisions, this.commaSeperatedZones, this.commaSeperatedRegions, this.selectedReqType, this.commaSeperatedRMH, this.isProduct,year, this.commaSeperatedStatus)
            .subscribe(
                success => {
                    if (success.ok = true) {
                        var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
                        saveAs(blob, this.selectedReqType + "_" + this.userName+"_"+year + "_" + this.tabName + "_FinalReq_" + formattedDate + ".xlsx");
                    }
                    this.loader = 'none';
                },
                err => {
                    //alert("No data found");
                    //alert("Some problem occurred while downloading file.");
                    this.toastr.error('No data found.');
                    this.loader = 'none';

                }
            );
    }

    approveFinalRequirementDetails(updateDetail, reqType) {
        debugger;
      
        if (updateDetail == undefined || updateDetail == null || updateDetail.length == 0) {
            this.toastr.error('No data found for approval.');
            this.displayApprove = 'none';
            this.loader = 'none';
            return false;
        }
        if (this.selectedRegionMessage.length >= 1) {
            for (var i = 0; i < this.selectedRegionMessage.length; i++) {
                if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager' && this.selectedRegionMessage[i].status == 'Approved By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + this.selectedRegionMessage[i].status);
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already Approval Pending at Brand Manager.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Approved By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already approved by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Rejected By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already rejected by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Rejected By DMH') {
                    // this.toastr.error(this.selectedRegionMessage[i].region + ' has already rejected by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Rejected By ZBM/ZMH') {
                    // this.toastr.error(this.selectedRegionMessage[i].region + ' has already rejected by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Rejected By SBUMH') {
                    // this.toastr.error(this.selectedRegionMessage[i].region + ' has already rejected by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
            }
        }
        if (this.regionSelect.selectedItems.length > 0) {
            this.regionCode = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        let product=Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let crop=Array.prototype.map.call(this.cropSelect.selectedItems, function (item) { return item.id; }).join(",");
        this.loader = 'block';
        this.IsRejected = false;
       // this.regionCode = '';
        this.displayApprove = 'none'
        this.displayReject = 'none';
        let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.finalRequirementService.approveFinalRequirementDetails(updateDetail, this.userId, this.roleId, reqType, this.regionCode, this.IsRejected, '',year,product,crop,this.commaSeperatedStatus)
            .subscribe((finalReqData) => {
                if (finalReqData.data[0].result == 'FAIL') {
                    this.toastr.error(finalReqData.data[0].errordescription);
                    this.defaultValue = 'none';
                    this.displayApprove = 'none';
                    this.displayReject = 'none';
                    this.loader = 'none';
                } else {
                    this.toastr.success(finalReqData.data[0].errordescription);
                    this.defaultValue = 'none';
                    this.displayApprove = 'none';
                    this.displayReject = 'none';
                    this.loader = 'none';
                }
                // if (finalReqData.message == "Success") {
                //     this.toastr.success('Data Approved Successfully.');
                //     // if (this.roleId == '1') {
                //     //     this.approveEnable = false;
                //     //     this.rejectEnable = false;
                //     // }
                //     // else {
                //     //     this.approveEnable = true;
                //     //     this.rejectEnable = true;
                //     // }

                //     this.loader = 'none';
                // }
                // else {
                //     this.toastr.error(finalReqData.message);
                //     this.loader = 'none';
                // }
               
            this.getFinalRequirementData(reqType);
            });
    }

    getApprovalHistory(currentPageForHistory: number) { 
        this.loader = 'block';
        this.isDisabledPreviousForHistory = true;
        this.isDisabledNextForHistory = false;
        this.startRecordForHistory=1;
        let region="";
        let currentpageForHistory = currentPageForHistory;
        let year=0;
        if (this.commaSeperatedSbus == undefined) {
            this.commaSeperatedSbus = '';
        }
        if (this.commaSeperatedDivisions == undefined) {
            this.commaSeperatedDivisions = '';
        }
        if (this.commaSeperatedZones == undefined) {
            this.commaSeperatedZones = '';
        } if (this.commaSeperatedRegions == undefined) {
            this.commaSeperatedRegions = '';
        }
        if (this.commaSeperatedRMH == undefined) {
            this.commaSeperatedRMH = '';
        }
        if(this.yearSelect!=undefined){
            this.yearSelect.selectedItems=[]; 
        }
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId'); 
        if (this.regionSelect.selectedItems.length > 0) {
            region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");

        this.finalRequirementService.getApprovalHistory(currentPageForHistory,this.userId, this.roleId, this.selectedReqType, this.commaSeperatedSbus, this.commaSeperatedDivisions, this.commaSeperatedZones, region, this.commaSeperatedRMH,year)
            .subscribe((approvalData) => {
                if(approvalData.data == null){
                    this.startRecordForHistory = 0;
                    this.recordsOnCurrentPageForHistory = 0;
                    this.endRecordForHistory = 0;
                    this.totalRecordForHistory = 0;
                    this.approvalDetails = [];
                    this.isDisabledNextForHistory = true;
                }
                else{
                    this.approvalDetails = approvalData.data.approvalHistoryModels;
                    this.totalRecordForHistory=approvalData.data.pagination.totalRecord;
                    this.currentPageForHistory= approvalData.data.pagination.currentPage; 
                    this.lastPageForHistory = approvalData.data.pagination.lastPage;
                    this.recordsOnCurrentPageForHistory = approvalData.data.pagination.recordsOnPage;
                    this.endRecordForHistory = this.recordsOnCurrentPageForHistory;
                    if (this.currentPageForHistory == 1)
                    {
                        localStorage.setItem("numberOfRecordsOnFirstPageForHistory", this.recordsOnCurrentPageForHistory.toString());
                    }
                    if (this.currentPageForHistory > 1)
                    {
                        this.isDisabledPreviousForHistory = false;
                        // this.startRecordForHistory = (this.currentPageForHistory - 1) * (approvalData.data.length) + 1;
                        this.startRecordForHistory = (this.currentPageForHistory - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPageForHistory"), 10) + 1;
                        this.endRecordForHistory = this.startRecordForHistory + this.recordsOnCurrentPageForHistory - 1;
                    }
                    if (this.currentPageForHistory == this.lastPageForHistory || this.totalRecordForHistory == 0) {
                        this.isDisabledNextForHistory = !this.isDisabledNextForHistory;
                        this.recordsOnCurrentPageForHistory = this.totalRecordForHistory;
                    }
                }
                this.loader = 'none';
            }, error => {
            this.loader = 'none';
        });
    }

    openCommentPopup(details) {
        if (details.length == 0) {
            this.toastr.error('No data found for rejection.');
            this.loader = 'none';
            return false;
        }
        if (this.selectedRegionMessage.length >= 1) {
            for (var i = 0; i < this.selectedRegionMessage.length; i++) {
                if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager' && this.selectedRegionMessage[i].status == 'Approved By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + this.selectedRegionMessage[i].status);
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already Approval Pending at Brand Manager.');
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Approved By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already approved by admin.');
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Rejected By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already rejected by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
            }
        }
        this.displayReject = 'block';
        this.comment = '';
    }

    closePopup(commentModal: string) {
        this.comment = commentModal;
        this.displayReject = 'none';
        this.comment = '';
        this.loader = 'none';
    }
    submitRejectedComment(comment: string) {
        this.loader = 'block';
        this.comment = comment;
        if (typeof (comment) == "undefined" || this.comment == '' || this.comment == null) {
            this.toastr.error('Please enter comment.');
            this.loader = 'none';
            return false;
        }
        this.IsRejected = true;
        this.displayReject = 'none';
        let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        let product=Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let crop=Array.prototype.map.call(this.cropSelect.selectedItems, function (item) { return item.id; }).join(",");
        this.finalRequirementService.approveFinalRequirementDetails(this.finalReqDetails, this.userId, this.roleId, this.selectedReqType, this.regionCode, this.IsRejected, this.comment,year,product,crop,this.commaSeperatedStatus)
            .subscribe((finalReqData) => {
                if (finalReqData.data[0].result == 'FAIL') {
                    this.toastr.error(finalReqData.data[0].errordescription);
                    this.loader = 'none';
                    this.approveEnable = true;
                    this.rejectEnable = true;

                } else {
                    this.toastr.success(finalReqData.data[0].errordescription);
                    this.loader = 'none';
                    this.approveEnable = true;
                    this.rejectEnable = true;

                }
                this.closePopup(this.comment);
                // if (this.roleId == '1') {
                //     this.approveEnable = false;
                //     this.rejectEnable = false;
                // }
                // else {
                //     this.approveEnable = true;
                //     this.rejectEnable = true;
                // }

                this.finalReqDetails = [];
                this.comment = "";
                this.loader = 'none';


            });
    }

    setSubMenu(event: any, type: string): void {
        this.tabName = type;
        this.getFinalRequirementData(this.selectedReqType);
    }
    openApproveCommentPopup(updateDetail, reqType) {
        if (updateDetail == undefined || updateDetail == null || updateDetail.length == 0) {
            this.toastr.error('No data found for approval.');
            this.displayApprove = 'none';
            this.loader = 'none';
            return false;
        }
        if (this.selectedRegionMessage.length >= 1) {
            for (var i = 0; i < this.selectedRegionMessage.length; i++) {
                if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager' && this.selectedRegionMessage[i].status == 'Approved By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + this.selectedRegionMessage[i].status);
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    this.approveEnable = true;
                    this.rejectEnable = true;
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Approval Pending at Brand Manager') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already Approval Pending at Brand Manager.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Approved By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + ' has already approved by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
                else if (this.selectedRegionMessage[i].status == 'Rejected By Admin') {
                    this.toastr.error(this.selectedRegionMessage[i].region + '  has already rejected by admin.');
                    this.displayApprove = 'none';
                    this.loader = 'none';
                    return false;
                }
            }
        }
        this.displayApprove = 'block';
    }
    closeApprovePopup() {
        this.displayApprove = 'none';
        this.loader = 'none';

    }


    // onStatusSelect(item: any) {
    //     this.selectedStatus = item.text
    //     this.StatusSetting();
    // }
    // onStatusDeSelect(item: any) {
    //     this.selectedStatus = '';
    // }
    public onStatusSelect(item: any) {

        this.selectedStatus = [];
        for (var i = 0; i < this.status.selectedItems.length; i++) {
            this.selectedStatus.push(this.status.selectedItems[i].text)
        }
        this.commaSeperatedStatus = this.selectedStatus.join(", ");
    }
    public onStatusDeSelect(item: any) {
        this.selectedStatus = [];
        for (var i = 0; i < this.status.selectedItems.length; i++) {
            this.selectedStatus.push(this.status.selectedItems[i].text)
        }
        this.commaSeperatedStatus = this.selectedStatus.join(", ");
    }

    public onStatusSelectAll(items: any) {
        this.selectedStatus = [];
        for (var i = 0; i < this.status.selectedItems.length; i++) {
            this.selectedStatus.push(this.status.selectedItems[i].text)
        }
        this.commaSeperatedStatus = this.selectedStatus.join(", ");
    }
    public onStatusDeSelectAll(items: any) {
        this.selectedStatus = [];
        this.commaSeperatedStatus = '';
    }
    remarkContent: string = '';
    remarkDate: string = '';
    isPartiallyclosed: boolean;
    onImageClick(remark: any,status: any) {
    
      const closedContent = remark.split('!split!');
      this.remarkDate = closedContent[0];
      const processedRemark = closedContent[1].replace(/\\n/g, '\n');
      
      this.remarkContent = processedRemark.replace(/\n/g, '<br>');
  
      if(status.includes('Partially'))
      {
        this.isPartiallyclosed = true
      }
      else{
        this.isPartiallyclosed = false
      }
      this.cd.detectChanges();
    }
}